export default __webpack_public_path__ + "static/media/MD-5700.a3d0eb14.png";